// extracted by mini-css-extract-plugin
module.exports = {"benefits":"Benefits_benefits__RGWQD","benefit":"Benefits_benefit__JQo80","image":"Benefits_image__j5bn3"};